import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  rewards: null as any[] | null,
  easySavingsTrx: null as any[] | null,
  lifetimeEarned: null as string | null,
  hasRewards: false,
  dashboardItems: [] as any[],
  dashboardTotalCount: 0,
  dashboardRewardType: 'ALL' as 'ALL' | 'CASHBACK' | 'REBATE',
  dashboardDaysSinceToday: 30,
  isLoading: false,
  error: null as string | null,
}

const bdmcRewardsSlice = createSlice({
  name: 'bdmcRewards',
  initialState,
  reducers: {
    fetchStart(state) {
      state.isLoading = true
      state.error = null
    },
    fetchSuccess(state, action) {
      const { rewards, easySavingsTrx, lifetimeEarned, hasRewards } = action.payload
      state.rewards = rewards
      state.easySavingsTrx = easySavingsTrx
      state.lifetimeEarned = lifetimeEarned
      state.hasRewards = hasRewards
      state.isLoading = false
    },
    dashboardFetchStart(state, action) {
      state.isLoading = true
      state.error = null
      state.dashboardRewardType = action.payload.rewardType
      state.dashboardDaysSinceToday = action.payload.daysSinceToday
    },
    dashboardFetchSuccess(state, action) {
      const { items, totalCount, lifetimeEarned, hasRewards, rewardType, daysSinceToday } =
        action.payload
      state.dashboardItems = items || []
      state.dashboardTotalCount = totalCount || 0
      state.dashboardRewardType = rewardType || state.dashboardRewardType
      state.dashboardDaysSinceToday = daysSinceToday || state.dashboardDaysSinceToday
      state.lifetimeEarned = lifetimeEarned
      state.hasRewards = hasRewards
      state.isLoading = false
    },
    fetchFailure(state, action) {
      state.error = action.payload
      state.isLoading = false
    },
  },
})

export const selectBdmcRewards = (state: any) => state.bdmcRewards.rewards
export const selectBdmcRewardsEasySavings = (state: any) => state.bdmcRewards.easySavingsTrx
export const selectBdmcRewardsLifetimeEarned = (state: any) => state.bdmcRewards.lifetimeEarned
export const selectBdmcRewardsHasRewards = (state: any) => state.bdmcRewards.hasRewards
export const selectBdmcRewardsDashboardItems = (state: any) => state.bdmcRewards.dashboardItems
export const selectBdmcRewardsDashboardTotalCount = (state: any) =>
  state.bdmcRewards.dashboardTotalCount
export const selectBdmcRewardsIsLoading = (state: any) => state.bdmcRewards.isLoading
export const selectBdmcRewardsError = (state: any) => state.bdmcRewards.error

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  dashboardFetchStart,
  dashboardFetchSuccess,
} = bdmcRewardsSlice.actions

export default bdmcRewardsSlice.reducer
